module.exports = __webpack_public_path__ + "Frame407-45001217.webp";